import React from 'react';
import { Descriptions } from 'antd';
import moment from 'moment';
import { ProgramInvoice, WEEKDAY_LABEL } from '@models/program-invoice';

const ProgramInvoiceDetailView: React.FC<{ invoice: Partial<ProgramInvoice> }> = ({ invoice }) => {
  const renderSchedule = () => {
    const { invoiceSchedule } = invoice;
    if (!invoiceSchedule) return '-';

    let scheduleText = '';
    if (invoiceSchedule.type === 'day') {
      scheduleText =
        invoiceSchedule.dates?.map((date) => moment(new Date(date)).format('YYYY.MM.DD HH:mm')).join(',\n') || '-';
    } else if (invoiceSchedule.type === 'week') {
      scheduleText =
        invoiceSchedule.weekdays?.map((weekday: string) => `${WEEKDAY_LABEL[weekday]}요일`).join(', ') || '-';
      if (invoiceSchedule.time) {
        scheduleText += ` ${invoiceSchedule.time.hour}:${String(invoiceSchedule.time.minute || '00').padStart(2, '0')}`;
      }
    } else if (invoiceSchedule.type === 'month') {
      scheduleText = `주 ${invoiceSchedule.weeklyFrequency || 1}회`;
      if (invoiceSchedule.time) {
        scheduleText += ` ${invoiceSchedule.time.hour}:${String(invoiceSchedule.time.minute || '00').padStart(2, '0')}`;
      }
    }
    return <div style={{ whiteSpace: 'pre-wrap' }}>{scheduleText}</div>;
  };

  const paymentTypeMap: Record<string, string> = {
    one_time: '이번만',
    weekly: '매주',
    monthly: '매월',
  };

  return (
    <Descriptions bordered column={1} labelStyle={{ width: 120 }} size="small">
      <Descriptions.Item label="파트너명">{invoice.seller?.name || '-'}</Descriptions.Item>
      <Descriptions.Item label="수강증 이름">{invoice.title || '-'}</Descriptions.Item>
      <Descriptions.Item label="상품명">{invoice.product?.name || '-'}</Descriptions.Item>
      <Descriptions.Item label="구매자">
        {invoice.representative?.name} ({invoice.representative?.id ? '회원' : '비회원'})
      </Descriptions.Item>
      <Descriptions.Item label="연락처">{invoice.representative?.phone || '-'}</Descriptions.Item>
      <Descriptions.Item label="수강생">
        {invoice.participants?.map((p) => `${p.name} (${p.birthYear}년생)`).join(', ') || '-'}
      </Descriptions.Item>
      <Descriptions.Item label="결제 정보">
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
          <div>
            <strong>상품 가격:</strong> {invoice.product?.requestAmount?.toLocaleString() || 0}원
          </div>
          <div>
            <strong>총 회차:</strong> {invoice.totalSessionCount || 1}회
          </div>
          {invoice.product?.applyGroupDiscount && (
            <div>
              <strong>그룹 할인:</strong> {invoice.groupDiscountTarget || 0}명 적용
            </div>
          )}
          <div>
            <strong>결제 주기:</strong> {paymentTypeMap[invoice.type || 'one_time'] || '-'}
          </div>
          <hr style={{ margin: '8px 0', border: 'none', borderTop: '1px solid #f0f0f0' }} />
          <div>
            <strong>최종 결제 금액:</strong> {invoice.amount?.toLocaleString() || 0}원
          </div>
        </div>
      </Descriptions.Item>
      <Descriptions.Item label="수강 정보">
        {invoice.duration
          ? `소요 시간: ${invoice.duration.hour || 0}시간 ${invoice.duration.minute || 0}분`
          : '소요 시간: -'}
      </Descriptions.Item>
      <Descriptions.Item label="수업 일정">{renderSchedule()}</Descriptions.Item>
      <Descriptions.Item label="결제유효시간">
        {invoice.validUntil ? moment(invoice.validUntil).format('YYYY.MM.DD HH:mm') : '-'}
      </Descriptions.Item>
      {invoice.status && <Descriptions.Item label="상태">{invoice.status}</Descriptions.Item>}
      <Descriptions.Item label="메모">{invoice.memo || '-'}</Descriptions.Item>
    </Descriptions>
  );
};

export default ProgramInvoiceDetailView;
